import React from "react";
import voucherIcon from "@/assets/images/aicopy/order-card-voucher.svg";
import cashIcon from "@/assets/images/aicopy/order-card-cash.svg";
import { getAicopyOrderCardCornerVariant } from "../../utils/orderCardCornerIcon";
import styles from "./index.module.less";

export default function OrderCardCornerBadge({ raw, variant, isCouponPosition, t, className }) {
  const resolvedVariant =
    variant ??
    (isCouponPosition != null ? (isCouponPosition ? "voucher" : "cash") : getAicopyOrderCardCornerVariant(raw));
  const isVoucher = resolvedVariant === "voucher";
  const label = isVoucher
    ? t?.("aicopy.orderWithVoucher") || "Voucher"
    : t?.("aicopy.orderWithCash") || "Cash";

  return (
    <div
      className={`${styles.badge} ${isVoucher ? styles.voucher : styles.cash}${className ? ` ${className}` : ""}`}
      aria-hidden
    >
      <img src={isVoucher ? voucherIcon : cashIcon} alt="" className={styles.icon} />
      <span className={styles.label}>{label}</span>
    </div>
  );
}
